import {
    CREATE_USER_URL,
    GET_JOB_TYPES_URL,
    GET_USER_DETAIL_V2_URL,
    GET_WAREHOUSE_STAFF_LISTING,
    GET_WAREHOUSE_URL, UPDATE_USER_URL, WAREHOUSE_STAFF_URL,
} from "../../config/Url";
import axios from "../../interceptors/axiosInterceptor";
import {getAuthOptions} from "../../config/Headers";
import {normalizeCatchErrors} from "../../utils/errorUtils";
import {
    ICreateUpdateStaffRequestPayload,
    IcreateUserPayload, ICreateWarehouseStaffUserRequestPayload,
    IGetQueryParams, IMultiSelectDropdownPayload,
    IUserDetailsResponseObject,
    IWarehousePayload, IWarehouseStaffListingResponse
} from "../../interfaces/Index";
import {normalizeJobTypesForDropdown} from "../../normalizer/WarehouseStaffNormalizers";

export const fetchWarehouseStaffListingApi = (options: IGetQueryParams = {}) =>
    new Promise<IWarehouseStaffListingResponse[]>((resolve, reject) => {
        let requestConfig: any = getAuthOptions();
        requestConfig.params = options;
        axios
            .get(GET_WAREHOUSE_STAFF_LISTING, requestConfig)
            .then((response) => {
                if (response) {
                    const data: IWarehouseStaffListingResponse[] = response.data;
                    resolve(data);
                } else {
                    reject({ errors: "Something went wrong" });
                }
            })
            .catch((error) => {
                const errorPayload = normalizeCatchErrors(error.response);
                reject(errorPayload);
            });
    });


export const getWarehouseStaffUserDetailsApi = (id: string) =>
    new Promise<IUserDetailsResponseObject>((resolve, reject) => {
        let url = GET_USER_DETAIL_V2_URL.replace("{user_id}", id);
        axios
            .get(url, getAuthOptions())
            .then((response) => {
                if (response) {
                    const data: IUserDetailsResponseObject = response.data;
                    resolve(data);
                } else {
                    reject({ errors: "Something went wrong" });
                }
            })
            .catch((error) => {
                const errorPayload = normalizeCatchErrors(error.response);
                reject(errorPayload);
            });
    });


export const getAllWarehousesApi = () =>
    new Promise<IWarehousePayload[]>((resolve, reject) => {
        axios
            .get(GET_WAREHOUSE_URL, getAuthOptions())
            .then((response) => {
                if (response) {
                    const data: IWarehousePayload[] = response.data;
                    resolve(data);
                } else {
                    reject({ errors: "Something went wrong" });
                }
            })
            .catch((error) => {
                const errorPayload = normalizeCatchErrors(error.response);
                reject(errorPayload);
            });
});


export const getAllJobTypesApi = () =>
    new Promise<IMultiSelectDropdownPayload[]>((resolve, reject) => {
        axios
            .get(GET_JOB_TYPES_URL, getAuthOptions())
            .then((response) => {
                if (response) {
                    const data: IMultiSelectDropdownPayload[] = normalizeJobTypesForDropdown(response.data);
                    resolve(data);
                } else {
                    reject({ errors: "Something went wrong" });
                }
            })
            .catch((error) => {
                const errorPayload = normalizeCatchErrors(error.response);
                reject(errorPayload);
            });
});

export const createStaffApi = (payload: ICreateUpdateStaffRequestPayload) => {
    return new Promise((resolve, reject) => {
        axios
            .post(WAREHOUSE_STAFF_URL, payload, getAuthOptions())
            .then((response) => {
                if (response) {
                    resolve(response.data);
                } else {
                    reject({ errors: "Something went wrong" });
                }
            })
            .catch((error) => {
                const errorPayload = normalizeCatchErrors(error.response);
                reject(errorPayload);
            });
    });
};

export const createUserApi = (payload: ICreateWarehouseStaffUserRequestPayload) =>
    new Promise<void>((resolve, reject) => {
        const userCreationPayload: IcreateUserPayload = userFrom(payload, payload.id);
        axios
            .post(CREATE_USER_URL, userCreationPayload, getAuthOptions())
            .then((response) => {
                if (response) {
                    resolve(response.data);
                } else {
                    reject({ errors: "Something went wrong" });
                }
            })
            .catch((error) => {
                const errorPayload = normalizeCatchErrors(error.response);
                reject(errorPayload);
            });
});

export const updateUserApi = (payload: ICreateWarehouseStaffUserRequestPayload) => {
    return new Promise((resolve, reject) => {
        const userId: string = payload.userId;
        const userUpdationPayload: IcreateUserPayload = userFrom(payload, userId);
        axios
            .put(UPDATE_USER_URL.replace("{user_id}", userId), userUpdationPayload, getAuthOptions())
            .then((response) => {
                if (response) {
                    resolve(response.data);
                } else {
                    reject({ errors: "Something went wrong" });
                }
            })
            .catch((error) => {
                const errorPayload = normalizeCatchErrors(error.response);
                reject(errorPayload);
            });
    });
};

export const updateStaffApi = (payload: ICreateWarehouseStaffUserRequestPayload) => {
    return new Promise((resolve, reject) => {
        const userId: string = payload.userId;
        const warehouseStaffCreationPayload : ICreateUpdateStaffRequestPayload = staffFrom(payload, userId);
        axios
            .put(WAREHOUSE_STAFF_URL, warehouseStaffCreationPayload, getAuthOptions())
            .then((response) => {
                if (response) {
                    resolve(response.data);
                } else {
                    reject({ errors: "Something went wrong" });
                }
            })
            .catch((error) => {
                const errorPayload = normalizeCatchErrors(error.response);
                reject(errorPayload);
            });
    });
};

export const userFrom = ( payload: ICreateWarehouseStaffUserRequestPayload, id: string): IcreateUserPayload => {
    return {
        id: id,
        name: payload.fullName,
        phone: payload.phoneNumber.trim(),
        password: payload.password,
        nationalId: payload.nationalId,
        email: payload.email,
        status: "ACTIVE",
        countryCode: "PK"
    };
};

export const staffFrom = (payload: ICreateWarehouseStaffUserRequestPayload, userId: string):
    ICreateUpdateStaffRequestPayload => {
    return {
        fullName: payload.fullName,
        phoneNumber: payload.phoneNumber.trim(),
        status: payload.status || "ACTIVE",
        title: payload.title || "BAZAAR_STAFF",
        userId: userId,
        warehouseId: payload.warehouseId,
        jobTypes: payload.jobTypes
    }
}